import { auth } from '@actions/auth';
import Button from '@ui/Button';
import Form from '@ui/Form';
import { InputFormField } from '@ui/Form/Fields';
import React, { FC } from 'react';
import { useForm } from 'react-hook-form';
import { I18n, Translate } from 'react-redux-i18n';
import { useRedux } from 'use-redux';
import styles from './styles.module.scss';

interface Props {
  onRegister: () => void;
}

const SignInParent: FC<Props> = ({ onRegister }) => {
  const [
    {
      auth: { user },
      i18n,
    },
    dispatch,
  ] = useRedux();

  const formMethods = useForm<FormData>({
    // resolver: yupResolver(getSchema(activeEntity)),
    mode: 'onChange',
  });

  const handleFormSubmit = async (values: any) => {
    dispatch(auth(values.email, values.password, false));
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        <span className={styles.stepTitle}>
          {I18n.t('onboarding.signinParent.title')}
        </span>
        <p className={styles.stepHint}>
          {I18n.t('onboarding.signinParent.info')}
        </p>
      </div>
      <div className={styles.right}>
        <Form formMethods={formMethods} onSubmit={handleFormSubmit}>
          <InputFormField
            name="email"
            placeholder={I18n.t('placeholder.email')}
          />
          <InputFormField
            type="password"
            name="password"
            placeholder={I18n.t('placeholder.password')}
          />

          <div className={styles.actionsWrapper}>
            <Button type="submit" color="green">
              <Translate value="auth.signin" />
            </Button>

            <Button color="green" onClick={onRegister}>
              <Translate value="auth.signup" />
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default SignInParent;
